'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageGroup = getMessageGroup;

var _PubNubMessageGroups = require('../../constants/PubNubMessageGroups');

var _PubNubMessageGroups2 = _interopRequireDefault(_PubNubMessageGroups);

var _isUnpublished = require('./isUnpublished');

var _isSimulated = require('./isSimulated');

var _isPublishFailed = require('./isPublishFailed');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMessageGroup(message) {
  if ((0, _isUnpublished.isUnpublished)(message) || (0, _isSimulated.isSimulated)(message) || (0, _isPublishFailed.isPublishFailed)(message)) {
    return _PubNubMessageGroups2.default.PUBLISHING;
  }
  return _PubNubMessageGroups2.default.HISTORY;
}